import React from 'react'
import styled from 'styled-components'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { IDS } from '../../MwPage/content'
import {
  blue,
  Eyebrow,
  Hi,
  ice,
  iceLine,
  ink,
  muted,
  paper,
  sans,
  Section,
  SectionHead,
  Stack,
  teal,
  ui,
} from '../../MwPage/styled'
import { fillTrial } from '../content/trial'
import { useFocus } from '../focus'
import { Column, H2, Wrap } from '../styled'

// the prototype's accordion: a card per question that opens on tap
const Item = styled.details`
  padding: 0 16px;
  border-radius: 20px;
  border: 1.5px solid ${iceLine};
  background: ${paper};

  summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 14px 0;
    list-style: none;
    cursor: pointer;
    font: 700 16px/1.4 ${sans};
    color: ${ink};
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary::after {
    content: '+';
    flex: none;
    display: grid;
    place-items: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: ${ice};
    color: ${teal};
    font-size: 18px;
    line-height: 1;
  }

  &[open] summary::after {
    content: '−';
  }

  p {
    margin: 0;
    padding: 0 0 14px;
    font-size: 15.5px;
    line-height: 1.6;
    color: ${muted};
  }
`

const New = styled.span`
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${blue};
  color: #ffffff;
  font: 800 10px/1.4 ${ui};
  letter-spacing: 0.1em;
  vertical-align: middle;
`

// each question reveals on its own
const Question = ({ item, answer, newTag }) => (
  <Item {...useRevealProps()}>
    <summary>
      <span>
        {item.q}
        {item.isNew && <New>{newTag}</New>}
      </span>
    </summary>
    <p>{answer}</p>
  </Item>
)

/** "Before you start": the questions, each opening on tap. On a trial page an answer can name the visitor's price. */
const FaqSection = ({ offer }) => {
  const { faq, trial } = useFocus()
  const answer = (item) => (trial ? fillTrial(item.a, offer, '…') : item.a)

  return (
    <Section id={IDS.faq}>
      <Wrap>
        <Stack $gap="clamp(24px, 3vw, 32px)">
          <SectionHead>
            <Eyebrow {...useRevealProps()}>{faq.eyebrow}</Eyebrow>
            <H2 {...useRevealProps()}>
              {faq.headline} <Hi>{faq.headlineAccent}</Hi>
            </H2>
          </SectionHead>
          <Column $max={820} $gap={8}>
            {faq.items.map((item) => (
              <Question key={item.q} item={item} answer={answer(item)} newTag={faq.newTag} />
            ))}
          </Column>
        </Stack>
      </Wrap>
    </Section>
  )
}

export default FaqSection
